module.exports = __webpack_public_path__ + "static/media/vctors-logo.5fabe92e.svg";